import React from 'react'
import Grid from '@mui/material/Grid'
import SimpleTextField from '../../../../../components/Forms/SimpleTextField'

const ETCO2 = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <SimpleTextField
      label="ETCO2"
      value={value}
      type="number"
      onChange={onChange}
      InputProps={{
        inputProps: { min: 0, max: 100, step: 'any' },
      }}
    />
  </Grid>
)

export default ETCO2
